var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "insure-claim" }, [
      _c("p", [_vm._v("\n    电子数据保全法律费用损失保险理赔资料\n  ")]),
      _c("p", [_vm._v("\n    尊敬的被保险人：\n  ")]),
      _c("p", [
        _vm._v(
          "首先感谢使用华安保险的电子数据保全法律费用损失保险，出险时请拨打95556报案，并提前准以理赔资料。"
        )
      ]),
      _c("p", [_vm._v("一、保单号")]),
      _c("p", [
        _vm._v("二、被保险人身份证（个人）或单位证件、如营业执照复印件等。")
      ]),
      _c("p", [_vm._v("三、保全备案号")]),
      _c("p", [
        _vm._v(
          "四、人民法院收取诉讼费用时向诉讼当事人开具的缴费凭证。基层巡回法庭当场收取诉讼费用的，出具省级人民政府财政部门印制的财政票据原件； "
        )
      ]),
      _c("p", [
        _vm._v("五、司法鉴定、公证费用及易保全出具易证据证书费用的发票原件； ")
      ]),
      _c("p", [
        _vm._v(
          "六、被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料， 如民事诉讼状、法院判决书、调解书、仲裁报告等复印件。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53053697", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53053697","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/signInfo/insureClaim.vue
// module id = Bhns
// module chunks = 223